<template>
  <a v-if="isHyperLink" v-bind="$attrs">
    <slot/>
  </a>
  <router-link v-else v-slot="{ href, navigate }" :to="$attrs.href" active-class="active-class"
               class="default-router-class"
  >
    <a :href="href" class="aClass" v-bind="$attrs" @click="navigate">
      <slot/>
    </a>
  </router-link>
</template>
<style scoped>

.active-class {
  background-color: #7eade0 !important;
  border-bottom: none;
  color: white !important;
}

.aClass:hover {
  background-color: #557598 !important;
}

.default-router-class {
  padding-left: 0;
  box-shadow: none !important;
}

.default-router-class:hover {
  background-color: #557598 !important;
}
</style>
<script>
export default {
  compatConfig: {
    MODE: 3,
    inheritAttrs: false,
  },
}
</script>

<script setup>
import {computed, getCurrentInstance} from 'vue'

// eslint-disable-next-line no-undef
const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
})

const router = getCurrentInstance().appContext.config.globalProperties.$router

const isHyperLink = computed(() => {
  return !!(!props.item.href || props.item.external || !router)
})
</script>
